import axios from "@/assets/js/axiosExtend";

const baseUrl = "/filebackend";

export async function getConfig(params) {
  const url = baseUrl + `/system/getConfig?env=${params}`;
  const res = await axios.get(url);
  return res;
}
export async function getBackendVersion() {
  //https://recordfile-test.tvunetworks.com/base/version
  const url = baseUrl + `/base/version`;

  const res = await axios.get(url);
  return res.data;
}

export function logout() {
  const url = baseUrl + "/user/logout";
  const res = axios.get(url);
  return res;
}
